// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__91EFN","img_wrapper":"styles_img_wrapper__sd3va","bullet_container":"styles_bullet_container__Qe_4n"};